/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ToolAnswerRequestCurrentFilters } from './toolAnswerRequestCurrentFilters';

export interface ToolAnswerRequest {
  tool_use_id: string;
  /** @maxLength 20000 */
  answer: string;
  current_filters?: ToolAnswerRequestCurrentFilters;
}
